import type React from 'react';

import { AcceptTermsAndConditionsPage } from '@xarvio/xfm-auth-remote-source/pages/AcceptTermsAndConditionsPage/AcceptTermsAndConditionsPage';
import { EmailVerifiedPage } from '@xarvio/xfm-auth-remote-source/pages/EmailVerifiedPage/EmailVerifiedPage';

export const loadEmailVerifiedPage = async (): Promise<{
  default: React.ComponentType;
}> => {
  return {
    default: EmailVerifiedPage,
  };
};

export const loadAcceptTermsAndConditionsPage = async (): Promise<{
  default: React.ComponentType;
}> => {
  return {
    default: AcceptTermsAndConditionsPage,
  };
};
